import { render, staticRenderFns } from "./FooterHeadline.vue?vue&type=template&id=0da2db85&"
import script from "./FooterHeadline.vue?vue&type=script&lang=js&"
export * from "./FooterHeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports